(<any>Symbol).dispose ??= Symbol("Symbol.dispose");
(<any>Symbol).asyncDispose ??= Symbol("Symbol.asyncDispose");